import { createSlice } from "@reduxjs/toolkit";

const employeeSlice = (name, defaultSortField = "created", defaultSortOrder = "desc") => {
  const initialState = {
    pagination: { page: 0, pageSize: 15 },
    sortModel: [{ field: defaultSortField, sort: defaultSortOrder }],
    searchText: "",
  };

  const slice = createSlice({
    name,
    initialState,
    reducers: {
      setPagination: (state, action) => {
        state.pagination = action.payload;
      },
      setSortModel: (state, action) => {
        state.sortModel = action.payload;
      },
      setSearchText: (state, action) => {
        state.searchText = action.payload;
      },
      resetPage: state => {
        state.pagination.page = 0;
      },
      resetState: state => Object.assign(state, initialState),
    },
  });

  return slice;
};


export const manageSlice = employeeSlice("manage", "created", "asc");
export const compOffInfoContentSlice = employeeSlice("compOffInfoContent", "createdAt", "desc");
export const leaveInfoContentSlice = employeeSlice("leaveInfoContent", "created", "desc");
export const wfhInfoContentSlice = employeeSlice("wfhInfoContent", "created", "desc");
export const projectInfoContentSlice = employeeSlice("projectInfoContent", "created", "desc");

export const employeeReducers = {
  manage: manageSlice.reducer,
  compOffInfoContent: compOffInfoContentSlice.reducer,
  leaveInfoContent: leaveInfoContentSlice.reducer,
  wfhInfoContent: wfhInfoContentSlice.reducer,
  projectInfoContent: projectInfoContentSlice.reducer,
};
